import { render } from "./JoinM.vue?vue&type=template&id=a287a460&scoped=true"
import script from "./JoinM.vue?vue&type=script&lang=js"
export * from "./JoinM.vue?vue&type=script&lang=js"

import "./JoinM.vue?vue&type=style&index=0&id=a287a460&scoped=true&lang=css"

import exportComponent from "G:\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a287a460"]])

export default __exports__